import React, {useCallback, useEffect, useState} from "react";
import "./SalePage.css";

import dropDownPerple from "asset/icon/ic_drop_down_purple_24dp.png";
import dropUpPerple from "asset/icon/ic_drop_up_purple_24dp.png";
import boxVideo from "asset/video/perplay_s_1.5bit.mp4";
import bannerCar1 from "asset/image/NFT_CAR01_2400.png";
import bannerCar2 from "asset/image/NFT_CAR02_2400.png";
import icHelp from "asset/icon/ic_help_outline_gray_24dp.svg";
import completedImg from "asset/image/img_completed.png";

import { useTranslation } from "react-i18next";
import { useSelector} from "react-redux";

function SalePage(props) {
    const walletConnected = useSelector(state => state.walletSlice.connected );
    const balance = useSelector(state => state.walletSlice.balance);
    const curSaleSchedule = useSelector(state => state.saleSlice.saleId);
    const amount = useSelector(state => state.saleSlice.amount);

    const [qtyDropBool,setQtyDropBool] = useState(false);
    const [dropPerple, setDropPerple] = useState(dropDownPerple);

    const {completeSchedule,funcMint,saleStatus } = props;
    // 가격
    const price = useSelector(state => state.saleSlice.price);
    const [discountRate,setDiscountRate] = useState("10%");
    // 구매 갯수
    const [boxCnt,setBoxCnt] = useState(0);
    const [totalPrice, setTotalPrice] = useState(0);
    const [payActive, setPayActive] = useState("");
    // 구매 가능 갯수
    const [qtyList, setQtyList] = useState([0]);

    useEffect(()=>{
        let list;

        if(saleStatus.saleId["PUBLIC"] === curSaleSchedule ){
            if(Number(amount)>=10){
                list = [0,1,2,3,4,5,6,7,8,9,10];
            }else{
                list = [0];
                for (let i=0; i<Number(amount); i+=1){
                    list.push(i+1);
                }
            }
        }else{
            if(Number(amount)>=3){
                list = [0,1,2,3];
            }else{
                list = [0];
                for (let i=0; i<Number(amount); i+=1){
                    list.push(i+1);
                }
            }
        }
        setQtyList(list);
    },[amount]);

    useEffect(()=>{
        setBoxCnt(0);
    },[qtyList]);

    const { t } = useTranslation();

    useEffect(()=>{
        switch (curSaleSchedule){
            case saleStatus.saleId["OG"]:
                setDiscountRate("10%");
                break;
            case saleStatus.saleId["WL"]:
                setDiscountRate("5%");
                break;
            default:
                setDiscountRate("");
                break;
        }
    },[curSaleSchedule]);

    useEffect(()=>{
        let total = price * boxCnt; // 추가로 세금 계산 붙어야됨.

        setTotalPrice(total);

        if(balance>= total && total !== 0 ){
            setPayActive("active");
        }else{
            setPayActive("");
        }
    },[boxCnt,curSaleSchedule]);

    const priceComponent = () => {
        if(curSaleSchedule !== saleStatus.saleId["OG"] && curSaleSchedule !== saleStatus.saleId["WL"]){
            return (
                <div className={"price-wrap"}>
                    <p className={"price"}>{price} <span className={"pay-token"}>MATIC [Polygon]</span></p>
                </div>
            );
        }else{
            return (
                <div className={"price-wrap"}>
                    <p className={"original-price-wrap"}><span className={"original-price"}>{saleStatus.salePrice["PUBLIC"]}</span> <span className={"discount-rate"}>{discountRate}</span></p>
                    <p className={"price"}>{price} <span className={"pay-token"}>MATIC [Polygon]</span></p>
                </div>
            );
        }
    }

    function funcHelpIconEnter (target){
        target.nextElementSibling.style.display="flex";
    }

    function funcHelpIconLeave (target){
        target.getElementsByClassName("tooltip-box")[0].style.display="none";
    }

    const funcQtyDropClick = useCallback (async ()=> {
        const dropdown = document.querySelector(".select-list-container");
        dropdown.classList.toggle("down");
        if(qtyDropBool){
            setQtyDropBool(false);
            setDropPerple(dropDownPerple);
        }else{
            setQtyDropBool(true);
            setDropPerple(dropUpPerple);
        }
    });


    const funcSelectQty = useCallback (async (v) => {
        setBoxCnt(v);
        await funcQtyDropClick();
    });

    useEffect(()=>{
        let total = price * boxCnt; // 추가로 세금 계산 붙어야됨.

        setTotalPrice(total);

        if(balance>= total && total !== 0){
            setPayActive("active");
        }else{
            setPayActive("");
        }
    },[price,boxCnt]);

    useEffect(()=>{
        //console.log(boxCnt);
    },[boxCnt]);

    function mintBtn () {
        if(walletConnected){
            return (
                <div>
                    <button
                        className={"pay-button"+" "+payActive}
                        onClick={(e)=>{if(e.currentTarget.classList.contains("active")){funcMint(boxCnt)}}}
                    >Mint</button>
                </div>
            )
        }else{
            return (
                <div>
                    <button
                        className={"pay-button"}
                        onClick={()=>funcMint(boxCnt)}
                    >{t('CONNECT_BUTTON')}</button>
                </div>
            )
        }
    }

    // 구매갯수 관련 함수 및 레이아웃

    const qtyInputLayout = () => {
        return (
            <>
                <div className={"select-container"}>
                    <div className={"select-header"}
                         onClick={funcQtyDropClick}
                    >
                        <span className={"selected-quantity"}>{boxCnt}</span>
                        <div className={"select-icon"}>
                            <img className={"quantity-dropdown-img"}
                                 src={dropPerple} width={40} height={40}
                                 alt={"dropDown"}/>
                        </div>
                    </div>
                    <div className={"select-list-container"}>
                        <ul className={"select-list"}>
                            {qtyList.map((v, idx) => {
                                const cur = document.querySelector(".selected-quantity");
                                if (cur !== undefined && cur !== null) {
                                    const cur_qty = cur.innerText;

                                    if (v + '' !== cur_qty) {
                                        return (
                                            <li key={"qty_"+idx}
                                                onClick={(e) => {
                                                    funcSelectQty(v)
                                                }}
                                            >{v}</li>
                                        );
                                    }
                                }
                            })}
                        </ul>
                    </div>
                </div>
            </>
        )
    };
    const SaleTitle = () => {
        let title;
        switch (curSaleSchedule){
            case saleStatus.saleId["OG"] :
                title = "OG Sale";
                break;
            case saleStatus.saleId["WL"] :
                title = "OG+WL Sale";
                break;
            case saleStatus.saleId["PUBLIC"]:
                title = "OG+WL+Public Sale";
                break;
            default:
                title = "OG Sale";
                break;
        }
        return title;
    }

    return (
        <div className={"sale-page"}>
            <div className={"sale-schedule-wrap"}>
                <ul className={"sale-schedule-list"}>
                    <li className={`event-wrap${curSaleSchedule !== "ECO" ? "": " active"} complete` }>
                        <div className={"sale-schedule-day"}></div>
                        <div className={"sale-schedule-line"}></div>
                        <h3 className={"sale-schedule-title"}>Private SALE</h3>
                        <div className={"sale-schedule-content"}>
                            {/*<p>13:00 UTC(24h)</p>*/}
                            <div>
                                {t('QTY',{"value":saleStatus.saleQty.ECO})}
                            </div>
                        </div>
                        <img className={"sale-schedule-completed-img"} src={completedImg} alt={"complete"}/>
                    </li>
                    <li className={`event-wrap${curSaleSchedule !== saleStatus.saleId["OG"] ? "": " active"}${completeSchedule.includes("OG") ? " complete" : ""}` }>
                        {/*<div className={"sale-schedule-day"}>May 2023</div>*/}
                        <div className={"sale-schedule-line"}></div>
                        <h3 className={"sale-schedule-title"}>OG SALE</h3>
                        <div className={"sale-schedule-content"}>
                            <p>11:00 UTC</p>
                            <div>
                                {t('QTY',{"value":saleStatus.saleQty.OG})}
                            </div>
                        </div>
                        <img className={"sale-schedule-completed-img"} src={completedImg} alt={"complete"}/>
                    </li>
                    <li className={`event-wrap${curSaleSchedule !== saleStatus.saleId["WL"] ? "": " active"}${completeSchedule.includes("WL") ? " complete" : ""}` }>
                        <div className={"sale-schedule-day"}></div>
                        <div className={"sale-schedule-line"}></div>
                        <h3 className={"sale-schedule-title"}>OG+WL SALE</h3>
                        <div className={"sale-schedule-content"}>
                            <p>12:00 UTC</p>
                            <div>
                                {t('QTY',{"value":saleStatus.saleQty.WL})}
                            </div>
                        </div>
                        <img className={"sale-schedule-completed-img"} src={completedImg} alt={"complete"}/>
                    </li>
                    <li className={`event-wrap${curSaleSchedule !== saleStatus.saleId["PUBLIC"] ? "": " active"}${completeSchedule.includes("PUBLIC") ? " complete" : ""}` }>
                        <div className={"sale-schedule-day"}></div>
                        <div className={"sale-schedule-line"}></div>
                        <h3 className={"sale-schedule-title"}>OG+WL+Public SALE</h3>
                        <div className={"sale-schedule-content"}>
                            <p>14:30 UTC</p>
                            <div>
                                {/*{t('PUBLIC_QTY',{"value":saleQty.PUBLIC})}*/}
                                REMAINING QTY
                            </div>
                        </div>
                        <img className={"sale-schedule-completed-img"} src={completedImg} alt={"complete"}/>
                    </li>
                </ul>
            </div>
            <div className={"sale-section"}>
                <h2 className={"sale-section-title"}>{SaleTitle()}</h2>
                <div className={"sale-section-wrap"}>
                    <div className={"sale-section-left"}>
                        <video className={"sale-image"}
                               autoPlay
                               loop
                               muted
                               playsInline
                               preload={"metadata"}
                               width={495}
                               height={495}
                        >
                            <source src={boxVideo} type="video/mp4"/>
                        </video>
                    </div>
                    <div className={"sale-section-right"}>
                        <div className={"payment-top"}>
                            <div className={"sale-row"}>
                                <div className={"payment-tooltip-wrap"}
                                    onMouseLeave={(e)=>{funcHelpIconLeave(e.currentTarget)}}
                                >
                                    <p className={"sale-text"}>Payment
                                    </p>
                                    {/*<span className={"payment-tooltip-icon tooltip-icon"}>?</span>*/}
                                    <img src={icHelp} width={24} height={24}
                                         onMouseEnter={(e)=>{funcHelpIconEnter(e.currentTarget)}}
                                    />
                                    <div className={"payment-tooltip tooltip-box"}>
                                        {t('PAYMENT_GUIDE')}
                                    </div>
                                </div>
                                <div className={"payment-method"}>
                                    MATIC
                                </div>
                            </div>
                        </div>
                        <hr className={"divider"}/>
                        <div className={"payment-middle"}>
                            <div className={"sale-row"}>
                                <div className={"sale-text-wrap"}>
                                    <p className={"sale-text"}>Price</p>
                                </div>
                                {priceComponent()}
                            </div>

                            <div className={"sale-row"}>
                                <div className={"sale-text-wrap"}>
                                    <p className={"sale-text"}>Quantity</p>
                                </div>
                                <div className={"quantity-wrap"}>
                                    {qtyInputLayout()}
                                </div>
                            </div>
                        </div>
                        <hr className={"divider"}/>
                        <div className={"payment-bottom"}>
                            <p className={"sale-text"}>Wallet</p>
                            <div className={"wallet-wrap"}>
                                <div className={"your-wallet-wrap"}>
                                    <div className={"your-wallet-text"}>
                                        {t('WALLET')}
                                    </div>
                                    <div className={"your-wallet"}>
                                        {balance}&nbsp;
                                        <span>MATIC</span>
                                    </div>
                                </div>
                                <div className={"total-price-wrap"}>
                                    <div className={"total-price-text"}>{t('TOTAL')}</div>
                                    <div className={"total-price"}>
                                        {totalPrice}&nbsp;
                                        <span>MATIC</span>
                                    </div>
                                </div>
                            </div>
                            {mintBtn()}
                        </div>
                    </div>
                </div>
            </div>
            <div className={"banner-container"}>
                <div className={"banner"}>
                    <div className={"banner-title"}>
                      <span>
                        <h1>GENESIS</h1>
                        <h2>NFT</h2>
                      </span>
                    </div>
                    <div className={"img-container"}>
                        <img className={"banner-img"} src={bannerCar1} alt={"car1"}/>
                    </div>
                    <div className={"img-container top-img"}>
                        <img className={"banner-img"} src={bannerCar2} alt={"car2"}/>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default SalePage;